import DropdownTexts from "./DropdownTexts";
import DownloadIcon from "../../../assets/Icons/DownloadIcon";
import ViewIcon2 from "../../../assets/Icons/ViewIcon2";
import { Button } from "../../../components/Buttons";
import Card from "../../../components/Card";
import DropIcon from "../../../assets/Icons/dropdownIcon.svg";
import { Link } from "react-router-dom";
import ChatIcon from "../../../assets/Icons/ChatIcon";
import { EMIText, LoanTenureText } from "../../Home/component/RecomendedLoanSection";
import { useState } from "react";
const ActiveLoanCard = ({ loanType, id, loanDate, totalAmount, interest, tenure, balance }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  return (<div className="flex">
    <Card className={"py-[18px] lg:px-[12px] xl:px-[18px] min-w-full md:min-w-[440px]"}>
      <div className="flex justify-between mb-[8px]">
        <div className="flex flex-col gap-[8px]">
          <div className="flex gap-[12px] cursor-pointer" onClick={toggleDropdown}>
            <p className="font-Apparat font-[700] text-[16px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%]">{loanType}</p>
            <img src={DropIcon} />
          </div>
          <p className="font-[600] text-[14px] md:text-[16px] text-[#42495280] leading-[18.5px] tracking-[-2%]">ID:
            <span className="text-[#424952]">{id}</span>
          </p>
        </div>
        <div className="col-span-1 flex justify-end">
          <div className="hidden md:flex">
            <Link class="text-primary font-Apparat font-[700] text-[18px] leading-[30px] tracking-[-2%]  flex items-center gap-[4px]">
              <ChatIcon />
              <span>Support</span>
            </Link>
          </div>
          <div className="flex md:hidden">
            <LoanTenureText title="Next Emi" value={`7 Dec 2024`} />
          </div>
        </div>
      </div>
      {!dropdownOpen && <div className="grid grid-cols-4  gap-[4px]">
        <div className="col-span-1">

          <LoanTenureText title="Total Amount" value={`₹ ${totalAmount}`} />
        </div>
        <div className="col-span-1  text-start">
          <div>
            <LoanTenureText title="interest" value={`${interest}`} />
          </div>
        </div>
        <div className="col-span-1 text-start">
          <div>
            <LoanTenureText title="tenure" value={`${tenure}`}
              className="hidden md:block"
            />
            <LoanTenureText title="emi" value={`20000`}
              className="block md:hidden"
            />
          </div>
        </div>
        <div className="col-span-1 text-end">
          <div className="text-end">
            <LoanTenureText
              className="hidden md:block"
              title="Balance"
              value={`₹ ${balance}`} />
            <Button className="flex md:hidden" title={`Pay`} />
          </div>
        </div>
      </div>}
      {dropdownOpen && <div className="flex flex-col gap-[12px] w-full">
        <DropdownTexts
          label={"Issued on"}
          value={loanDate}
        />
        <DropdownTexts
          label="Loan ID"
          value={id}
        />
        <DropdownTexts
          label="AMOUNT"
          value={`₹ 60000`}
        />
        <DropdownTexts
          label="RATE"
          value={`₹ 6000`}
        />
        <DropdownTexts
          label="EMI"
          value={`₹ 4000`}
        />
        <DropdownTexts
          label="Installments Paid"
          value={`2/6`}
        />
        <div className="flex justify-center gap-[4px]">
          <p className="font-Apparat font-[500] text-[12px] leading-[12px] tracking-[-2%] text-[#424952]">PAY NEXT EMI</p>
          <p className="font-Apparat font-[700] text-[12px] leading-[12px] tracking-[-2%] text-[#00C08B]">DUE IN 7 DAYS</p>
        </div>
        <Button className="w-full flex justify-center" title={`Pay ₹ 4000`} />
        <p className="font-Apparat font-[700] text-[20px] leading-[24px] tracking-[-2%] text-[#424952]">Foreclose Loan</p>
        <DropdownTexts
          label={"Issued on"}
          value={loanDate}
        />
        <DropdownTexts
          label="Loan ID"
          value={id}
        />
        <DropdownTexts
          label="AMOUNT"
          value={`₹ 60000`}
        />
        <DropdownTexts
          label="RATE"
          value={`₹ 6000`}
        />
        <DropdownTexts
          label="EMI"
          value={`₹ 4000`}
        />
        <DropdownTexts
          label="Installments Paid"
          value={`2/6`}
        />
        <Button variant="quaternary" className="w-full flex justify-center" title={`Pay ₹ 2000`} />
        <div className="flex  justify-center items-center gap-[4px] text-[#424952]">
          <DownloadIcon height="15" width="15" />
          <p className="font-Apparat font-[500] text-[16px] leading-[12px] ">Download Payment History</p>
        </div>
        <div className="flex  justify-center items-center gap-[4px] text-[#424952]">
          {/* <DownloadIcon height="15" width="15" /> */}
          <ViewIcon2 />
          <p className="font-Apparat font-[500] text-[16px] leading-[12px] ">View Payment History</p>
        </div>
      </div>}
    </Card>
    <Card className="col-span-3 hidden md:flex flex-col justify-between lg:gap-[2px] xl:gap-[9px] border-dashed border-2 h-[164px]  lg:px-[8px] xl:px-[12px]">
      <div className="grid grid-cols-2 gap-[34px]">
        <div className="grid-span-1">
          <EMIText title="Next EMI" value={`feb 5 2024`} />
        </div>
        <div className="grid-span-1 text-end">
          <EMIText title="EMI Paid" value={`1/3`} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-[34px]">
        <div className="grid-span-1">
          <h4 className="font-filson-soft font-[700] text-[30px] leading-[37.5px] tracking-[-2%] text-[#424952]">₹ 5000</h4>
        </div>
        <div className="grid-span-1 text-end">
          <Button title={"Pay"} />
        </div>
      </div>
    </Card>
  </div>)
}
export default ActiveLoanCard;